import { IPlanCode } from '../../../utils/Interfaces';
import ReactivateCouponInputContainer from '../../../components/ReactivateCouponInputContainer';
import styles from './PriceSummary.module.scss';
import {
  IReactivateMembershipContext,
  useReactivateMyMembershipContext,
} from '../../../utils/ContextProviders/ReactivateContext';
import { useReactivatePlanDataContext } from '../../../utils/ContextProviders/ReactivatePlanDataContext';

export const PRICE_SUMMARY_MESSAGES = {
  [IPlanCode.ANNUAL]: 'Annual Subscription',
  [IPlanCode.SEASONAL]: 'Seasonal Subscription',
  shippingLabel: 'Shipping*',
  promoCodeLabel: 'Promo Code',
  taxLabel: 'Tax',
  totalLabel: 'Total',
  labelCouponCode: 'Got a Coupon Code?',
};

const PriceSummary = () => {
  const { growthMyMembership } = useReactivateMyMembershipContext();
  const { variables } = growthMyMembership as IReactivateMembershipContext;
  const { seasonMembershipName } = variables;
  const { selectedPlanCode, basePrice, shippingPrice, taxPrice, totalPrice } =
    useReactivatePlanDataContext();
  const { shippingLabel, taxLabel, totalLabel } = PRICE_SUMMARY_MESSAGES;
  const selectedPlanLabel = PRICE_SUMMARY_MESSAGES[selectedPlanCode];

  const PriceHeadline = () => (
    <div className={styles.priceHeadline}>
      <div>
        <p>{selectedPlanLabel}</p>
        <p>
          1st Box - <span>{seasonMembershipName}</span>{' '}
        </p>
      </div>
      <p>${basePrice}</p>
    </div>
  );

  return (
    <div className={styles.pricePlanSummary}>
      <PriceHeadline />
      <div className={styles.pricesPlanDetail}>
        <ReactivateCouponInputContainer />
        <ItemRow title={shippingLabel} price={shippingPrice} withDivider />
        <ItemRow title={taxLabel} price={taxPrice} withDivider />
        <ItemRow title={totalLabel} price={totalPrice} currency="USD" boldTitle />
      </div>
    </div>
  );
};

const Divider = () => <div className={styles.itemPriceDivider} />;

interface ItemRowProps {
  title: string;
  price: number;
  withDivider?: boolean;
  currency?: string;
  boldTitle?: boolean;
}

const ItemRow = ({
  title,
  price,
  withDivider = false,
  currency,
  boldTitle = false,
}: ItemRowProps) => (
  <>
    <div className={styles.itemPrice}>
      <p className={boldTitle ? styles.bold : ''}>{title}</p>
      <p>
        ${price.toFixed(2)} {currency}
      </p>
    </div>
    {withDivider && <Divider />}
  </>
);

export default PriceSummary;
